import routerHelper from "helpers/routerHelper";
import documentService from "services/documentService";
import settingRepository from "repositories/settingRepository";
import { DispatchTemplateService } from "services/dispatch-template-service";
import { autoinject } from "aurelia-dependency-injection";
@autoinject()
export class MaterialOrderDocumentAdd {
    public readonly: boolean = false;
    public dispatchProjectCode: number | null = null;
    public dispatchProjectDate: string | null = null;

    public actions: any = {};
    public isCategorySelectionAllowed: boolean = false;

    constructor(
        private readonly dispatchTemplateService: DispatchTemplateService
    ) {}

    public async activate(params: any): Promise<void> {
        const paramsQueryString = routerHelper.getQuerystring(params.q);
        this.readonly = !(paramsQueryString && paramsQueryString.readonly === "false");

        this.setupHeaderInfos(params.dispatchProjectCode, params.dailyEntryDate);

        await this.setAction(params.orderId);
    }

    private setupHeaderInfos(projectCode: number, date: string): void {
        this.dispatchProjectCode = projectCode;
        this.dispatchProjectDate = date;
    }

    private async setAction(orderId: string): Promise<void> {
        const dispatchTemplateId = settingRepository.getDispatchTemplate();
        const dispatchTemplate = await this.dispatchTemplateService.GetDispatchTemplatesByCode(dispatchTemplateId!);
        this.isCategorySelectionAllowed = dispatchTemplate!.AllowCategorySelection;

        this.actions = {
            save: documentService.addDocumentByPurchaseOrderId.bind(self, orderId, dispatchTemplateId)
          };
    }
}
